<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="10">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                this.$l('tips_search') || '部门/团队/业务/客户/工厂 搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <div>
              <el-select
                class="ml-2"
                v-model="form.queryYear"
                size="mini"
                :placeholder="$l('tips_select_year') || '请选择预算年度'"
                style="width:120px;"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <el-radio-group
                v-model="form.queryType"
                fill="#317CF6"
                size="mini"
                class="ml-2"
                @change="query"
              >
                <el-radio-button label="A">{{
                  $l('tips_delivery_date') || '按下单交期统计'
                }}</el-radio-button>
                <el-radio-button label="B">{{
                  $l('tips_shipment_date') || '按出货批次统计'
                }}</el-radio-button>
              </el-radio-group>
            </div>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="1000px"
      :close-on-click-modal="false"
    >
      <el-form
        ref="form"
        :model="form"
        label-width="135px"
        size="small"
        label-position="right"
      >
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$l('table_depName') || '业务部门'">
              <dict-select
                size="small"
                clearable
                v-model="form.depCode"
                url="/sys/common/dict/depPrimary"
                :placeholder="$l('tips_select_dep') || '请选择部门'"
                filterable
                @change="updateTeamCode"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('table_teamName') || '业务团队'">
              <dict-select
                clearable
                v-model="form.teamCode"
                url="/sys/common/dict/depByParentCode"
                :placeholder="$l('tips_select_team') || '请选择团队'"
                :body="teamparams"
                filterable
                :disabled="!form.depCode"
                size="small"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="
                $l('INDEX.order_form_label_salesPersonCode') || '业务人员'
              "
            >
              <dict-select
                clearable
                v-model="form.salesPersonCode"
                filterable
                size="small"
                url="/master/common/dict/baseUserSelect"
                :placeholder="
                  $l('INDEX.form_label_please_select_a_business_person') ||
                    '请选择业务人员'
                "
                :selectedLabel.sync="form.salesPersonName"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              size="small"
              :label="$l('INDEX.order_form_label_custCode') || '下单客户'"
            >
              <dict-select
                clearable
                v-model="form.custCode"
                filterable
                url="/master/common/dict/customerSelect"
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('table_label_masterCategoryName') || '产品主分类'"
            >
              <dict-select
                :placeholder="$l('INDEX.tips_select_data') || '请选择'"
                size="small"
                clearable
                filterable
                v-model="form.masterCategoryCode"
                :body="{ parentCode: 'ABSHome' }"
                url="/master/masterCategory/select"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('table_label_orderType') || '订单类型'">
              <dict-select
                filterable
                size="small"
                clearable
                v-model="form.orderType"
                :body="orderTypeParams"
                url="/sys/common/dict/system"
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-row>
              <el-form-item :label="$l('table_label_rptOrderMonth') || '年月'">
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.rptOrderMonthBegin"
                    type="month"
                    size="small"
                    value-format="yyyy-MM"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.rptOrderMonthEnd"
                    type="month"
                    size="small"
                    value-format="yyyy-MM"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">{{
          $l('INDEX.btn_cancel_query') || '取消查询'
        }}</el-button>
        <el-button size="small" type="warning" @click="reset">{{
          $l('INDEX.btn_reset_filter') || '重置条件'
        }}</el-button>
        <el-button size="small" type="primary" @click="advquery">{{
          $l('INDEX.btn_data_retrieval') || '数据检索'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  keyword: '',
  queryType: 'A',
  queryYear: '',
  orderType: '',
}
export default {
  data() {
    return {
      advqueryDialogVisible: false,
      teamparams: { parentCode: '' },
      orderTypeParams: { dictType: 'orderType' },
      form: { ...initForm },
      curYear: '',
      options: [],
    }
  },
  watch: {
    'form.depCode'() {
      this.teamparams = { parentCode: this.form.depCode }
    },
  },
  activated() {
    this.init()
  },
  methods: {
    init() {
      this.loading = true
      this.listData = []
      this.$api.orderBudgetAnalysisGetBudgetYearApi({}).then((res) => {
        this.loading = false
        this.options = res.body.data
        this.curYear = this.options[0].value
        this.form.queryYear = this.curYear
        this.query()
      })
    },
    fromLoad(val) {
      this.$emit(val)
    },
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
      this.form.queryType = 'A'
      this.form.queryYear = this.curYear
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
    updateTeamCode() {
      this.form.teamCode = ''
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
